export const quickIdControlRegex = /^([A-Z0-9]){1,3}$/;
